import {
  getFragmentData,
  ProductFragmentDoc,
  wishlistService
} from '@/fo/api/magento';
import { toastBase } from '@/fo/ui/kit/toast/base';

import { storeProduct } from '../lib/store';

const addProductToWishlist = async (
  sku: string,
  quantity = 1,
  parentSku?: string
) => {
  const response = await wishlistService.addProductToWishlist(
    sku,
    quantity,
    parentSku
  );

  if (response.errorMessage) {
    return toastBase(response.errorMessage, { status: 'error' });
  }

  if (response?.wishlist && response?.items) {
    response.items.forEach((item) => {
      const product = getFragmentData(ProductFragmentDoc, item?.product);
      if (product && product.sku) {
        storeProduct.send({
          type: 'setProductWishlist',
          sku: product.sku,
          wishlist: {
            id: item?.id ?? '',
            count: item?.quantity ?? 1
          }
        });
      }
    });
  }
};

const removeWishlistItems = async (
  items: { sku: string; wishlistItemId: string }[]
) => {
  const wishlistItemIds = items.map((item) => item.wishlistItemId);
  const response = await wishlistService.removeWishlistItems(wishlistItemIds);

  if (response.errorMessage) {
    return toastBase(response.errorMessage, { status: 'error' });
  }

  items.forEach(({ sku }) => {
    storeProduct.send({
      type: 'setProductWishlist',
      sku,
      wishlist: undefined
    });
  });
};

export const wishlistActions = {
  addProductToWishlist,
  removeWishlistItems
};
